


























































import { Component, Vue, Watch } from "vue-property-decorator";
import Card from "@/components/ui/card/Card.vue";
import { chartModule, jimizzModule } from "@/store";
import { Round, round } from "@/helpers/round.helper";
import * as ApexCharts from "apexcharts";
import Loader from "@/components/ui/Loader.vue";
import { PriceHistory } from "@/store/chart/price-history";

// Due to the fact that ApexCharts is not directly managed by Vue,
// using `this` in the yAxis.max function always returns 0.
// /!\ Keep this value outside the class
let maxValue = 0;

@Component({
  components: { Loader, Card },
})
export default class DashboardChart extends Vue {
  type = "eur";
  series: { data: [number, number][] }[] = [];

  options = {
    chart: {
      sparkline: {
        enabled: true,
      },
    },
    stroke: {
      curve: "smooth",
    },
    tooltip: {
      custom: ({
        series,
        dataPointIndex,
      }: {
        series: number[][];
        dataPointIndex: number;
      }) => `$${round(series[0][dataPointIndex], Round.Floor, 6)}`,
    },
    colors: ["#7B61FF"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
    },
    yaxis: {
      max: () => {
        return maxValue * 1.1;
      },
    },
  };

  get loading(): boolean {
    return chartModule.isLoading;
  }

  get price(): number {
    return round(this.series[0]?.data.slice(-1)[0][1], Round.Floor, 6) ?? 0;
  }

  get percent(): number {
    if (this.series[0]?.data.length) {
      const today = this.series[0]?.data.slice(-1)[0][1] ?? 0;
      const yesterday = this.series[0]?.data.slice(-2)[0][1] ?? 0;

      return round(((today - yesterday) / yesterday) * 100, Round.Round);
    }

    return 0;
  }

  get balancePrice(): number {
    return round(this.price * this.balance, Round.Floor, 4) ?? 0;
  }

  get balance(): number {
    const balance = jimizzModule.balance;
    return round(balance);
  }

  get history(): PriceHistory[] {
    return chartModule.history;
  }

  async mounted(): Promise<void> {
    await chartModule.fetch();
  }

  update(): void {
    maxValue = Math.max(
      ...this.history.map((h) => (this.type === "eur" ? h.eur : h.usd))
    );
    const data = this.history.map((h) => [
      +h.date,
      this.type === "eur" ? h.eur : h.usd,
    ]) as [number, number][];
    this.series = [{ data }];
    (this.$refs.chart as unknown as ApexCharts)?.updateSeries([
      {
        data,
      },
    ]);
  }

  @Watch("history")
  onHistoryChanged(): void {
    if (this.history?.length) {
      this.update();
    }
  }

  @Watch("type")
  onTypeChanged(): void {
    this.update();
  }
}
